import MarkerWithLabel from '@google/markerwithlabel';
import '@PROJECT_ROOT/assets/desktop/js/jquery/plugins/jquery.jcarousel.min.0.2.9';
import '@PROJECT_ROOT/assets/desktop/js/guide/guideGallery';
import guideMap from '@PROJECT_ROOT/assets/desktop/js/guide/guideMap';
import guideCalendar from '@PROJECT_ROOT/assets/desktop/js/guide/guideCalendar';
import guideInlineGallery from '@PROJECT_ROOT/assets/desktop/js/guide/guideInlineGallery';

window.MarkerWithLabel = MarkerWithLabel;
window.guideMap = guideMap;

guideCalendar();
guideInlineGallery();
